import { useQuery } from "react-query";
import { getOfficeBrands } from "../../../../actions/CarrierAgreementMgmt/OfficeSettings";

export const useGetBrand = () => {
  return useQuery("GetBrand", getOfficeBrands, {
    // refetchOnWindowFocus: false,
  });
};
